import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from './Header';
import GoogleMap from './utils/GoogleMap';
import './scss/pitchDetails.scss';

function PitchDetails() {
  const { pitchId } = useParams();
  const [pitch, setPitch] = useState(null);
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    const fetchPitchDetails = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/fetch_pitches.php`);
        const result = await response.json();
        if (result.success) {
          const selectedPitch = result.pitches.find(p => p.pitch_id === pitchId);
          setPitch(selectedPitch);
        } else {
          console.error('Failed to fetch pitch details');
        }
      } catch (error) {
        console.error('Error fetching pitch details:', error);
      }
    };

    fetchPitchDetails();
  }, [pitchId]);

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/fetch_teams_by_pitch.php?pitch_id=${pitchId}`);
        const result = await response.json();
        if (result.success) {
          setTeams(result.teams);
        } else {
          console.error('Failed to fetch teams:', result.message);
        }
      } catch (error) {
        console.error('Error fetching teams:', error);
      }
    };

    fetchTeams();
  }, [pitchId]);

  if (!pitch) return <div>Loading...</div>;

  const facilitiesList = pitch.facilities.split(',').map((facility, index) => (
    <li key={index}>{facility.trim()}</li>
  ));

  const address = `${pitch.address_1}, ${pitch.address_2}, ${pitch.town}, ${pitch.county}, ${pitch.postcode}`;

  return (
    <div className="PitchDetails container">
      <Header />
      <button className="back-button" onClick={() => window.history.back()}>← Back</button>
      <h1>{pitch.name}</h1>
      <GoogleMap addresses={[address]} />
      <div className="details-columns">
        <div className="facilities">
          <h2>Facilities</h2>
          <ul>{facilitiesList}</ul>
        </div>
        <div className="address">
          <h2>Address</h2>
          <p>{pitch.address_1}, {pitch.address_2}, {pitch.town}, {pitch.county}, {pitch.postcode}</p>
          <button onClick={() => window.open(`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`, '_blank')}>Directions</button>
          <h2>Contact:</h2>
          <p>{pitch.organiser_contact}</p>
        </div>
      </div>
      {teams && teams.length > 0 && (
        <div className="teams">
            <h2>Teams Who Play Here:</h2>
            <div className="team-grid">
            {teams.map((team, index) => (
                <div key={index} className="team-card">
                <h3>{team.team_name}</h3>
                <p>Lead Organiser:<br/><strong>{team.admin_name} {team.admin_last_name}</strong></p>
                <p>Looking for Players:<br/><strong>{team.open_to_new_players == 1 ? 'Yes' : 'No'}</strong></p>
                <p>Time:<br/><strong>{team.play_schedule}</strong></p>
                </div>
            ))}
            </div>
        </div>
      )}
    </div>
  );
}

export default PitchDetails; 

